import React from 'react'
import {Switch, Route} from 'react-router-dom'
import CheckoutConfirm from '../components/CheckoutConfirm';
import CheckoutPayment from '../components/CheckoutPayment';
import CheckoutShipping from '../components/CheckoutShipping';
import LoginScreen from '../screens/LoginScreen';

const CheckoutScreen = ({match}) => {
  return (
    <div>
      <Switch>
          <Route exact path={match.url}><LoginScreen/></Route>
          <Route path={`${match.url}/shipping`}><CheckoutShipping/></Route>
          <Route path={`${match.url}/payment`}><CheckoutPayment/></Route>
          <Route path={`${match.url}/confirm`}><CheckoutConfirm/></Route>
      </Switch>
    </div>
  )
}

export default CheckoutScreen